import { BracketRoundHeader, BracketRow, ShuffleColumn } from "../styles";
import {
  depthToRoundTitleSingleElim,
  getMaxDepth,
  getNodesByDepth,
  ShuffleBracketGraph,
  ShuffleBracketNode,
} from "model/Bracket/ShuffleBracketGraph";
import { ShuffleBracketRowMatch } from "./ShuffleBracketRowMatch";
import { BracketMatchArgs } from "../BracketMatchArgs";
import { JSX } from "react";

interface Props {
  bracketGraph: ShuffleBracketGraph;
  tournamentId: string;
  bracketMatchArgs?: BracketMatchArgs;
}

export const SingleElimShuffleBracket = ({
  bracketGraph,
  tournamentId,
  bracketMatchArgs,
}: Props) => {
  const nodesByDepth = getNodesByDepth(bracketGraph.finalNodes, false);
  const maxDepth = getMaxDepth(nodesByDepth.flat());
  const { nodeCells, titleCells } = mapRow(
    nodesByDepth,
    maxDepth,
    tournamentId
  );

  return (
    <div style={{ padding: "10px", marginTop: "10px" }}>
      <BracketRow>{titleCells}</BracketRow>
      <BracketRow>{nodeCells}</BracketRow>
    </div>
  );
};

const mapRow = (
  nodesByDepth: ShuffleBracketNode[][],
  maxDepth: number,
  tournamentId: string
) => {
  const nodeCells: JSX.Element[] = [];
  const titleCells: JSX.Element[] = [];
  const hasMultipleFinals = nodesByDepth[0].length > 1;
  for (var i = 0; i < nodesByDepth.length; i++) {
    const currentColumn = nodesByDepth[i];

    const nodeColumnContents: JSX.Element[] = [];
    currentColumn.forEach((n) => {
      nodeColumnContents.push(
        <ShuffleBracketRowMatch node={n} tournamentId={tournamentId} />
      );
    });

    nodeCells.unshift(<ShuffleColumn>{nodeColumnContents}</ShuffleColumn>);
    titleCells.unshift(
      <ShuffleColumn>
        <BracketRoundHeader isLower={false}>
          {depthToRoundTitleSingleElim(i + 1, maxDepth, hasMultipleFinals)}
        </BracketRoundHeader>
      </ShuffleColumn>
    );
  }

  return { nodeCells, titleCells };
};
